import {Component, Input, OnInit} from '@angular/core';
import {Area} from '@core/area';
import {LandEvent} from '@core/broadcaster/LandEvent';
import {OpenLandModalEvent} from '../../../events/OpenLandModalEvent';
import {ThingService} from "@core/thing/thing.service";
import { ThingsUtil } from '../../../util/things';
import { IMAGE_BASE_PATH } from '../../../constants/images.constants';

@Component({
  selector: 'area-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less']
})
export class AreaCardComponent implements OnInit {
  @Input()
  public land: Area;
  public things: Array<any> = [];
  public activeCans: Number = 0;
  public activeRestrooms: Number = 0;
  public totalCans: Number = 0;
  public totalRestrooms: Number = 0;
  public activeTimeBased: Number = 0;
  public totalTimeBased: Number = 0;

  constructor(private thing: ThingService, private landEvent: LandEvent, private openLandModalEvent: OpenLandModalEvent, private thingsUtil: ThingsUtil) {}

  ngOnInit() {
    this.thing.getThingsByArea(this.land.areaId)
      .then(things => {
        this.things = things ? things : [];

        let cans = this.things.filter(thing => this.thingsUtil.isCan(thing));
        let restrooms = this.things.filter(thing => this.thingsUtil.isRestroom(thing));
        let timeBased = this.things.filter(thing => this.thingsUtil.isTimeBasedTask(thing));

        this.totalCans = cans.length;
        this.totalRestrooms = restrooms.length;
        this.activeCans = cans.filter(can => !can.deactivated).length;
        this.activeRestrooms = restrooms.filter(restroom => !restroom.closed).length;
        this.totalTimeBased = timeBased.length;
        this.activeTimeBased = timeBased.filter(timeBased => !timeBased.closed).length;
      });
  }

  getImageUrl() {
    if (this.land && this.land.imageSrc) {
      return IMAGE_BASE_PATH + 'areas/' + this.land.imageSrc;
    } else {
      return '/assets/images/lands/default.jpg';
    }
  }

  editLand($event) {
    $event.preventDefault();
    $event.stopPropagation();
    //this.landEvent.fire(this.land);
    this.openLandModalEvent.fire('edit', this.land);
    // popup Edit Modal
  }

  showThings($event) {
    $event.preventDefault();
    $event.stopPropagation();
    // go to page to show things for area
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/card/card.component.ts